import { Paper } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { ReportingSchedulerTable } from './ReportingSchedulerTable';
import { Props } from '../../container';

export const ReportingScheduler = (props: Props): JSX.Element => {
  const [pageSize, setPageSize] = useState<number>(100);
  const [page, setPage] = useState<number>(0);

  useEffect(() => {
    props.fetchScheduledEventList({
      page: page,
      pageSize: pageSize,
    });
  }, [page, pageSize]);

  const deleteScheduledEvent = (id: string) => {
    props
      .deleteScheduledEvent(id)
      .unwrap()
      .then(() => {
        props.fetchScheduledEventList({
          page: page,
          pageSize: pageSize,
        });
      });
  };

  return (
    <Paper elevation={4}>
      <ReportingSchedulerTable
        fetchScheduledEventListProgress={props.fetchScheduledEventListProgress}
        paginatedEventListResults={props.reporting.bulk.paginatedEventListResults}
        deleteScheduledEventProgress={props.deleteScheduledEventProgress}
        deleteScheduledEvent={deleteScheduledEvent}
        page={page}
        pageSize={pageSize}
        setPage={setPage}
        setPageSize={setPageSize}
      />
    </Paper>
  );
};
